'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Ripped from Modernizr
function hasLocalStorage() {
  var val = 'modernizr';
  try {
    window.localStorage.setItem(val, val);
    window.localStorage.removeItem(val);
    return true;
  } catch (e) {
    return false;
  }
}
var useLocalStorage = hasLocalStorage();

var StorageUtility = {
  set: function set(key, value) {
    if (useLocalStorage) {
      window.localStorage.setItem(key, value);
    }
  },

  get: function get(key) {
    if (useLocalStorage) {
      return window.localStorage.getItem(key);
    }
  }
};

exports.default = StorageUtility;